import {
  VuexModule,
  Module,
  Action,
  Mutation,
  getModule
} from 'vuex-module-decorators'
import store from '@/store'
import CookiesUtils from '@/common/utils/CookiesUtils'
import JavaHttp from '@/common/network/JavaHttp'

export interface UserState {
  id: string
  account: string
  phone: string
  name: string
  token: string
  loginPlate: string
  avatar: string
  levelId: string
  roleId: string
  provinceCode: string
  cityCode: string
  countyCode: string
  streetCode: string
  roles: Array<any>
  permissions: Array<any>
}

// 参数一：module名称，开启命名空间后会以name为命名空间
// 参数二：是否使用动态加载，简而言之只有在用到当前的module才会加载，详细可以看vuex官网。本篇博客必须选择true，
//        这也是为什么index.ts一直不用修改的原因，如果设置为false会有很大的变动，如果您真的需要这么做，可以自己研究一下，
//        或者私信我。
// 参数三：是否开启命名空间，如果你的模块很多，强烈建议开启
// 参数四：挂载的store目标
@Module({ name: 'user', dynamic: true, namespaced: true, store })
export default class User extends VuexModule implements UserState {
  public name = ''
  public avatar = ''
  public id = CookiesUtils.getUser()
  public account = ''
  public desensitizeFlag = 0
  public phone = ''
  public token = CookiesUtils.getToken()
  public loginPlate = ''
  public levelId = ''
  public roleId = ''
  public provinceCode = ''
  public cityCode = ''
  public countyCode = ''
  public streetCode = ''
  public roles: Array<any> = []
  public permissions: Array<any> = []

  get getToken() {
    return this.token
  }

  @Mutation
  private SET_ID(id: string) {
    this.id = id
  }

  @Mutation
  private SET_ACCOUNT(account: string) {
    this.account = account
  }

  @Mutation
  private SET_DESENSITIZEFLAG(desensitizeFlag: number) {
    this.desensitizeFlag = desensitizeFlag
  }

  @Mutation
  private SET_PHONE(phone: string) {
    this.phone = phone
  }

  @Mutation
  private SET_NAME(name: string) {
    this.name = name
  }

  @Mutation
  private SET_TOKEN(token: string) {
    this.token = token
  }

  @Mutation
  private SET_LOGINPLATE(loginPlate: string) {
    this.loginPlate = loginPlate
  }

  @Mutation
  private SET_LEVELID(levelId: string) {
    this.levelId = levelId
  }

  @Mutation
  private SET_ROLEID(roleId: string) {
    this.roleId = roleId
  }

  @Mutation
  private SET_ROLES(roles: Array<any>) {
    this.roles = roles
  }

  @Mutation
  private SET_PERMISSIONS(permissions: Array<any>) {
    this.permissions = permissions
  }

  @Mutation
  private SET_PROVINCECODE(provinceCode: string) {
    this.provinceCode = provinceCode
  }
  @Mutation
  private SET_CITYCODE(cityCode: string) {
    this.cityCode = cityCode
  }
  @Mutation
  private SET_COUNTYCODE(countyCode: string) {
    this.countyCode = countyCode
  }
  @Mutation
  private SET_STREETCODE(streetCode: string) {
    this.streetCode = streetCode
  }

  @Action
  public saveUserInfo(userInfo: any) {
    if (userInfo.token) {
      CookiesUtils.setToken(userInfo.token)
      CookiesUtils.setUser(userInfo.id)
      this.SET_ID(userInfo.id)
      this.SET_ACCOUNT(userInfo.account)
      this.SET_DESENSITIZEFLAG(userInfo.desensitizeFlag)
      this.SET_NAME(userInfo.name)
      this.SET_PHONE(userInfo.phone)
      this.SET_TOKEN(userInfo.token)
      this.SET_LEVELID(userInfo.levelId)
      this.SET_ROLEID(userInfo.roleId)
      this.SET_PROVINCECODE(userInfo.provinceCode)
      this.SET_CITYCODE(userInfo.cityCode)
      this.SET_COUNTYCODE(userInfo.countyCode)
      this.SET_STREETCODE(userInfo.streetCode)
      this.SET_LOGINPLATE(userInfo.loginPlate)

      this.SET_ROLES(userInfo.roles)
      this.SET_PERMISSIONS(userInfo.permissions)
    }
  }

  @Action
  public localUserInfo() {
    let userInfo = CookiesUtils.getPermissions()
    if (userInfo) {
      this.saveUserInfo(userInfo)
    }
  }

  @Action
  public clearUserInfo() {
    this.SET_ID('')
    this.SET_ACCOUNT('')
    this.SET_DESENSITIZEFLAG(0)
    this.SET_NAME('')
    this.SET_PHONE('')
    this.SET_TOKEN('')
    this.SET_LEVELID('')
    this.SET_ROLEID('')
    this.SET_LOGINPLATE('')
    this.SET_PROVINCECODE('')
    this.SET_CITYCODE('')
    this.SET_COUNTYCODE('')
    this.SET_STREETCODE('')
    this.SET_ROLES([])
    this.SET_PERMISSIONS([])
    CookiesUtils.removeToken()
    CookiesUtils.removeUser()
    CookiesUtils.removeRoles()
    CookiesUtils.removePermissions()
  }

  @Action
  public LogOut() {
    this.clearUserInfo()
  }

  // @Action
  // public async GenerateRoutes() {
  //   const url = '/menu/getRouters'
  //   const ret: any = await new Promise((resolve) => {
  //     request({
  //       url: '/menu/getRouters',
  //       method: 'get',
  //       params: ''
  //     })
  //       .then((res: any) => {
  //         resolve(res)
  //       })
  //       .catch((e: any) => {
  //         console.error(escape)
  //       })
  //   })
  //   let temp = staticRouters(false)
  //   let newMenu = DynamicRoutes.parseRouteArray(ret.data, '')
  //   AppModule.updateHomeMenu(newMenu)
  //   temp.concat(newMenu)
  //   console.log(temp)
  //   return temp
  // }
}

export const UserModule = getModule(User)
